import classNames from "classnames"
import { RouterLink } from "@lib/routing"
import ButtonBgSvg from "@assets/media/safer-dating/button-bg.svg"

import type { RouterLinkProps } from "@lib/routing"

export type SaferDatingButtonProps = {
  renderAs?: "routerLink" | "button"
} & Partial<RouterLinkProps>

export function SaferDatingButton({
  children,
  className,
  renderAs = "routerLink",
  uri = "",
  ...otherProps
}: SaferDatingButtonProps) {
  const baseClasses =
    "inline-block relative text-center tracking-[0.5px] transition-opacity duration-100 ease-in hover:opacity-75 min-w-[230px] py-6 text-[14px] leading-[18px] tablet-m:min-w-[310px] tablet-m:px-6 tablet-m:py-[28px] tablet-m:text-[20px] tablet-m:leading-[30px]"

  const renderContent = (
    <>
      <ButtonBgSvg className="absolute top-0 left-0 w-full h-full" />
      <span className="inline-flex relative text-white uppercase font-sans-bold">
        {children}
      </span>
    </>
  )

  if (renderAs === "routerLink") {
    return (
      <RouterLink
        {...otherProps}
        uri={uri}
        className={classNames(baseClasses, className)}
      >
        {renderContent}
      </RouterLink>
    )
  } else {
    return (
      <button
        onClick={otherProps.onClick}
        type="button"
        className={classNames(baseClasses, className)}
      >
        {renderContent}
      </button>
    )
  }
}
